import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/donate',
      name: 'donate',
      component: () => import(/* webpackChunkName: "about" */ './views/Donate.vue')
    },
    {
      path: '/:posturl',
      name: 'post',
      component: () => import(/* webpackChunkName: "post" */ './views/Post.vue')
    }
  ]
})
